import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  CreateOverrideInput,
  CreateOverrideVariables,
  CreateOverrideMutationResponse,
} from '../types';

const createOverrideMutation = gql`
  mutation CreateOverride($input: CreateOverrideInput!) {
    payrollCreateOverride(input: $input) {
      code
      success
      message
      data
    }
  }
`;

export const createOverride = (
  input: CreateOverrideInput,
): Promise<CreateOverrideMutationResponse> => {
  return graphQLApi<CreateOverrideMutationResponse, CreateOverrideVariables>({
    query: createOverrideMutation,
    queryVariables: {
      input,
    },
  });
};

